import axios from 'axios'
import setConfig from '@/config/axios-config'
setConfig(axios)

// const basePath = '/MarkServer/json/mark'
const baseRolePath = '/UserService/roles'
const baseUserPath = '/InfoServer/user'
const userPath = '/UserService'
const basePath = '/BaseInfoWeb/action'
const axiosConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

/**
 * 查询用户信息
 * @author wangk 2018-12-05T09:56:37+0800
 * @param  {"userId":"1573546927395"}
 * @return {[type]}        [description]
 */
const getUserInfo = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${baseUserPath}/user.jsp`, `app=getUserInfo&flag=detail&json=${json}`, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询用户信息
 * @author chenxb 2023-07-06T15:56:37+0800
 * @param  {"userId":"1573546927395"}
 * @return {[type]}        [description]
 */
const getCurrentUserInfo = () => {
  return axios.get(`${userPath}/users/current.jsp`, '', axiosConfig)
    .then(res => res.data)
}
/**
 * 重置用户错误密码输入次数
 * @author chenxb 2023-07-06T15:56:37+0800
 * @param  {"userId":"1573546927395"}
 * @return {[type]}        [description]
 */
const resetLoginErrorCount = (params = {}) => {
  return axios.post(`${basePath}/baseinfo/resetLoginErrorCount`, params)
    .then(res => res.data)
}
/**
 * 查询角色列表
 * @author wangk 2018-12-05T09:56:37+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const addRole = (params = {}) => {
  return axios.post(baseRolePath + '/addRole', params)
    .then(res => res.data)
}

const deleteRole = (params = {}) => {
  return axios.post(baseRolePath + '/deleteRole', params)
    .then(res => res.data)
}

const updateRoleInfo = (params = {}) => {
  return axios.post(baseRolePath + '/updateRoleInfo', params)
    .then(res => res.data)
}

const queryRoles = (params = {}) => {
  return axios.post(baseRolePath + '/queryRoles', params)
    .then(res => res.data)
}
/**
 * 修改信息管理员密码
 * @author wangk 2018-11-21T10:20:17+0800
 * @param  {Object} params { name: '张三', mobilePhone: '', roleName: '' }
 * @return {[type]}        [description]
 */
const resetInformationManagerPwd = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${baseUserPath}/user.jsp`, `app=updateUser&flag=update&json=${json}`, axiosConfig)
    .then(res => res.data)
}

export {
  getUserInfo,
  getCurrentUserInfo,
  resetLoginErrorCount,
  addRole,
  deleteRole,
  updateRoleInfo,
  queryRoles,
  resetInformationManagerPwd
}



// WEBPACK FOOTER //
// ./src/model/user-model.js